import React from 'preact/compat';

import Divider from '@mui/material/Divider'
import Typography from "@mui/material/Typography";

import colors from '../colors';

const LauncherFeatureStackCategoryTitle = ({ title, large }) => {
    return <Typography
        align="left"
        variant="h2"
        sx={{
            fontSize: large ? '32px' : '24px',
            fontWeight: 600,
            marginBottom: '24px',
            marginTop: 0,
            color: colors.primaryText
        }}
    >
        {title}
        <Divider
            sx={{
                marginTop: '4px',
                borderColor: colors.inputBorder,
                borderBottomWidth: 2
            }}
        />
    </Typography>
};

export default LauncherFeatureStackCategoryTitle;
